// extracted by mini-css-extract-plugin
export var icon = "_wz-0";